module.exports = __webpack_public_path__ + "static/media/Icon5.43de515e.png";